export const qualificationLabels = {
  need: "Besoin exprimé",
  decisionMaker: "Interlocuteur de décision",
  deadline: "Échéance",
  documents: "Documents disponibles",
  budget: "Budget transport et période",
  carriers: "Transporteurs",
  volumes: "Volumes d’expédition",
  controls: "Contrôles actuels",
} as const;
export type QualificationKey = keyof typeof qualificationLabels;
export const qualificationKeys = Object.keys(qualificationLabels) as QualificationKey[];
export const auditCriteria: QualificationKey[] = ["need", "decisionMaker", "deadline", "documents"];

export interface QualificationSource {
  kind: "notes" | "message";
  id: string;
  ticketId?: string;
  date: string;
  quote: string;
}
export interface QualificationFact {
  value: string;
  source: QualificationSource;
}
export interface QualificationData {
  facts: Partial<Record<QualificationKey, QualificationFact>>;
  manual: Partial<Record<QualificationKey, string | null>>;
  conflicts: Partial<Record<QualificationKey, QualificationFact>>;
  approvedVersion?: number;
  approvedAt?: string;
  approvedBy?: string;
  excludedReason?: string;
  analyzedAt?: string;
  partial?: boolean;
}
export interface Qualification {
  version: number;
  available: boolean;
  enabled: boolean;
  status: "pending" | "running" | "idle" | "quota" | "error";
  stage: "incomplete" | "review" | "ready" | "out_of_scope";
  fields: Record<
    QualificationKey,
    {
      value: string | null;
      manual: boolean;
      source: QualificationSource | null;
      suggestion: QualificationFact | null;
    }
  >;
  missing: QualificationKey[];
  approvedAt: string | null;
  approvedBy: string | null;
  excludedReason: string | null;
  analyzedAt: string | null;
  partial: boolean;
  nextAttemptAt: number;
}
